import { Shield } from 'lucide-react';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-quantum-dark/80 border-t border-white/10 py-4">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-2">
        <div className="flex items-center gap-2">
          <Shield className="w-4 h-4 text-quantum-primary" />
          <span className="text-sm text-quantum-light">Quantum Genesis © {year}</span>
        </div>
        <p className="text-xs text-quantum-light/50 text-center md:text-right">
          Always do your own research. Not financial advice.
        </p>
      </div>
    </footer>
  );
}
